const actionTypes = {
  SET_CORPORATE_INFO: 'setCorporateInfo',
  SET_CORPORATE_PAGE_STATUS: 'setCorporatePageStatus',
  SET_CORPORATE_ID: 'setCorporateId',
}

export default actionTypes
